import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const useModelTrainingJobStatus = (modelId, modelDetails) => {
    const [modelStatusLoading, setModelStatusLoading] = useState(false);
    const [modelStatusError, setModelStatusError] = useState(null);
    const history = useHistory();

    useEffect(() => {
        const isCandidate = modelDetails?.status.some(obj => {
            return obj.name === "OBSERVATION"
        });

        const isPredictionsCompleted = modelDetails?.training_status == "Model Predictions Completed"
        const cam_id = modelDetails?.cam_id;
        if (modelId && modelDetails && isCandidate && !isPredictionsCompleted && cam_id) {
            history.push(`/models/job/${cam_id}`)
        }
    }, [modelId, modelDetails]);

    return { modelStatusLoading, modelStatusError };
};

export default useModelTrainingJobStatus;